<template>
  <material-card
    color="secondary"
    title="Profile"
  >
    <v-form ref="form">
      <v-container class="py-0">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.name"
              label="Name"
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.email"
              :rules="emailRules"
              prepend-icon="mdi-email"
              label="Email address"
              class="purple-input"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.password"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              label="Password"
              :type="show ? 'text' : 'password'"
              :rules="passwordRules"
              @click:append="show = !show"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="repeatPassword"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              label="Repeat Password"
              :type="show ? 'text' : 'password'"
              :rules="repeatPasswordRules"
              @click:append="show = !show"
            />
          </v-col>
          <v-col
            v-if="user && user.role && user.role.toLowerCase() === 'admin'"
            cols="12"
            md="6"
          >
            <v-select
              v-model="user.role"
              :items="roles"
              label="Role"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <template v-slot:actions>
      <v-btn
        color="primary"
        :loading="loading"
        @click="submit"
      >
        Update Profile
      </v-btn>
    </template>
  </material-card>
</template>

<script>
  export default {
    props: {
      profile: {
        type: Object,
        required: true
      },
      onUpdate: {
        type: Function,
        required: true
      }
    },
    data () {
      return {
        roles: ['Customer', 'Editor', 'Admin'],
        loading: false,
        show: false,
        repeatPassword: '',
        passwordRules: [
          v => (!this.repeatPassword || v === this.repeatPassword) || 'Passwords do not match!',
          v => !!v || 'Password is required'
        ],
        repeatPasswordRules: [
          v => !!v || 'Password repeat required',
          v => v === this.user.password || 'Passwords do not match!'
        ],
        user: {
          ...this.profile
        },
        emailRules: [
          v => !!v || 'Email is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid',
        ]
      }
    },
    mounted () {
      this.user.role = this.capitalize(this.user.role)
    },
    methods: {
      onAvatarChange (file) {
        if (file) {
          this.file = file
        } else {
          this.file = 'none'
        }
      },
      submit () {
        if (this.$refs.form.validate()) {
          this.loading = true
          this.api.put('user', this.user)
            .then(result => {
              this.loading = false
              var updatedUser = result.data
              this.onUpdate(updatedUser)
            }, error => {
              this.loading = false
              this.error = error
            })
        }
      }
    }

  }
</script>
